import "core-js";
import * as React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { Redirect, Route, Switch } from "react-router";
import store, { browserHistory } from "@features/store";
import { ErrorBoundary } from "@appsignal/react";
import ErrorPage from "../../components/ErrorPage/ErrorPage";
import { SET_SERVER_PROPS } from "./features/actionTypes";
import { setUserData, setSecondaryMarketData } from "./features/action.market";
import ScrollToTop from "../CompaniesPageApp/components/HOC/ScrollToTop";
import OverviewPage from "./pages/OverviewPage/OverviewPage";
import Submenu from "../../components/Submenu/Submenu";
import SMSubmenu from "./components/SMSubmenu/SMSubmenu";
import MarketPage from "./pages/MarketPage/MarketPage";
import MyTradesPage from "./pages/MyTradesPage/MyTradesPage";
import MyOrdersPage from "./pages/MyOrdersPage/MyOrdersPage";
// import ErrorBoundary from '@appComponents/ErrorBoundary/ErrorBoundary';
import SPVsContainer from "./components/SPVsContainer/SPVsContainer";
import { classNames as cn } from "@features/utils/reactFunctions";

import { appsignal } from "./../../appsignal";

interface ISecondaryMarketApp {
  userSignedIn: boolean;
  userCountry?: string;
}

import * as app from "./SMAppStyle.module.scss";

const App = (props: ISecondaryMarketApp) => {
  const paddingNeeded = [
    "/market/spvs",
    "/market/my_trades",
    "/market/my_orders",
  ].includes(window.location.pathname);

  const isUk = props.userCountry === "GB";

  return (
    <div className={cn(paddingNeeded && app.adjustingPadding)}>
      <div className={app.submenuSticky}>
        <Submenu>
          <SMSubmenu isUk={isUk} userSignedIn={props.userSignedIn} />
        </Submenu>
      </div>
      <Switch>
        <Route path="/error/:errorCode" component={ErrorPage} />
        <Route exact={true} path={"/market"} render={() => <OverviewPage />} />
        <Route
          path={`/market/spvs/:asset_id`}
          render={(_props) => <MarketPage {..._props} />}
        />
        <Route
          exact={true}
          path={"/market/spvs"}
          render={() => <SPVsContainer />}
        />
        {props.userSignedIn && (
          <Route path={"/market/my_trades"} component={MyTradesPage} />
        )}
        {props.userSignedIn && (
          <Route
            exact={true}
            path={"/market/my_orders"}
            component={MyOrdersPage}
          />
        )}
        <Redirect from="/" to={"/market"} />
      </Switch>
    </div>
  );
};

class SecondaryMarketApp extends React.Component<ISecondaryMarketApp, {}> {
  componentDidMount() {
    store.dispatch({
      type: SET_SERVER_PROPS,
      payload: this.props,
    });

    if (this.props.userSignedIn) {
      store.dispatch(setUserData()).then((investorId: number) => {
        store.dispatch(setSecondaryMarketData(investorId));
      });
    } else {
      store.dispatch(setSecondaryMarketData());
    }
  }
  render() {
    return (
      <ErrorBoundary instance={appsignal}>
        <Provider store={store}>
          <ConnectedRouter history={browserHistory}>
            <ScrollToTop>
              <App {...this.props} />
            </ScrollToTop>
          </ConnectedRouter>
        </Provider>
      </ErrorBoundary>
    );
  }
}

export default SecondaryMarketApp;
